import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=765b7def&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=765b7def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b7def",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765b7def')) {
      api.createRecord('765b7def', component.options)
    } else {
      api.reload('765b7def', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=765b7def&scoped=true&", function () {
      api.rerender('765b7def', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u77omFMFc92s/JS/comp/PopupBox.vue"
export default component.exports